import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/site/Layout";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Portfolio from "@/components/site/Portfolio";
import About from "@/components/site/About";
import Contact from "@/components/site/Contact";
import ScrollToTop from "@/components/site/ScrollToTop";
import ServicesIndex from "@/pages/ServicesIndex";
import ServiceDetail from "@/pages/ServiceDetail";

function Home() {
  return (
    <Layout>
      <div data-testid="home-page">
        <Hero />
        <Marquee />
        <Services />
        <Portfolio />
        <About />
        <Contact />
      </div>
    </Layout>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<ServicesIndex />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Toaster
        position="top-center"
        richColors
        toastOptions={{
          style: {
            borderRadius: 0,
            border: "1px solid #111110",
            fontFamily: "'IBM Plex Sans', sans-serif",
          },
        }}
      />
    </BrowserRouter>
  );
}
